module.exports = __webpack_public_path__ + "img/Swap Icon.7358deb0.svg";